module.exports = __webpack_public_path__ + "img/iluminacion.5042a1d3.svg";